import React from "react";
import { useTranslation } from "react-i18next";
import "./index.css";
import Disposal45Header from "./Header";
import { ShowHide } from "../components/ShowHideProduct";
import { usePDFShowHide } from "../../../../hooks/usePDFShowHide";
import Flow45_1 from "./Flow45_1";
import Flow45_2 from "./Flow45_2";

const ProdDisposal45Components = ({ productId }) => {
  const { t } = useTranslation();
  const [show, setShow] = usePDFShowHide(false, {
    forceShowInPDF: true,
    pdfDelay: 1000,
  });

  return (
    <div className="disposal-45-container" id="disposal-45-id">
      <Disposal45Header productId={productId} show={show} />
      <ShowHide show={show} setShow={setShow} />
      {show && (
        <div className="disposal-45-content">
          {/* Flow 45.1 */}
          <Flow45_1 productId={productId} />

          {/* Flow 45.2 */}
          <Flow45_2 productId={productId} />
        </div>
      )}
    </div>
  );
};

export default ProdDisposal45Components;

